TS.ns('WL');


WL.leasingOfferBaseModel = new Class({
    Extends: WL.documentBase,

    initialize: function (config) {
        var me = this;

        me.parent(config);
    },

    createProperties: function (config) {
        var me = this;

        me.parent(config); 
    }

});